var _Object$keys = require('babel-runtime/core-js/object/keys').default;

(function () {
  Flint.file('mframework/views/carousel.js', function (require) {
    var _reactMotion = require('react-motion');

    Flint.staticStyles('Carousel', {
      '$': '#_flintapp .ViewCarousel',
      '$leftSection': '#_flintapp leftSection.Carousel, #_flintapp .Carousel.leftSection, #_flintapp .ViewCarousel.leftSection, #_flintapp .Carousel > .leftSection',
      '$midSection': '#_flintapp midSection.Carousel, #_flintapp .Carousel.midSection, #_flintapp .ViewCarousel.midSection, #_flintapp .Carousel > .midSection',
      '$things': '#_flintapp things.Carousel, #_flintapp .Carousel.things, #_flintapp .ViewCarousel.things, #_flintapp .Carousel > .things',
      '$leftShadow': '#_flintapp leftShadow.Carousel, #_flintapp .Carousel.leftShadow, #_flintapp .ViewCarousel.leftShadow, #_flintapp .Carousel > .leftShadow',
      '$rightShadow': '#_flintapp rightShadow.Carousel, #_flintapp .Carousel.rightShadow, #_flintapp .ViewCarousel.rightShadow, #_flintapp .Carousel > .rightShadow',
      '$rightSection': '#_flintapp rightSection.Carousel, #_flintapp .Carousel.rightSection, #_flintapp .ViewCarousel.rightSection, #_flintapp .Carousel > .rightSection',
      '$Sortable': '#_flintapp .ViewCarousel .ViewSortable',
      '$dot': '#_flintapp dot.Carousel, #_flintapp .Carousel.dot, #_flintapp .ViewCarousel.dot, #_flintapp .Carousel > .dot',
      '$thing': '#_flintapp thing.Carousel, #_flintapp .Carousel.thing, #_flintapp .ViewCarousel.thing, #_flintapp .Carousel > .thing'
    }, {
      '$': {
        flexDirection: 'row',
        alignItems: 'center'
      },
      '$leftSection': {},
      '$midSection': {
        flexDirection: 'row',

        position: 'relative'
      },
      '$things': {
        overflow: 'hidden'
      },
      '$leftShadow': {
        position: 'absolute',
        pointerEvents: 'none',
        zIndex: 2,
        top: 0,
        left: 0,
        bottom: 0,

        background: 'linear-gradient(to right, rgba(100, 100, 100, 0.8) 0%, rgba(150, 150, 150, 0) 100%)'
      },
      '$rightShadow': {
        position: 'absolute',
        pointerEvents: 'none',
        zIndex: 2,
        top: 0,
        right: 0,
        bottom: 0,

        background: 'linear-gradient(to left, rgba(100, 100, 100, 0.8) 0%, rgba(150, 150, 150, 0) 100%)'
      },
      '$rightSection': {},
      '$Sortable': {
        flexDirection: 'row'
      },
      '$dot': {
        zIndex: 1,

        margin: [0, 4],
        borderRadius: '50%'
      },
      '$thing': {
        position: 'absolute'
      }
    });
    Flint.view('Carousel', function (view, on, $) {
      var context = initContext(view, {
        colors: atom()
      });

      var pro = initPro(view, {
        children: atom(),
        width: M.defaultAtom(200),
        buttonWidth: M.defaultAtom(40),
        height: M.defaultAtom(200),
        sortable: M.defaultAtom(false),
        initialSelectedIndex: atom(),
        selectedIndex: atom(),
        shadows: M.defaultAtom(false),
        showButtons: M.defaultAtom(true),
        wrapMode: M.defaultAtom('rewind'), // 'rewind'|'cylinder'|false
        style: M.mergeAtom({
          button: {
            border: 'none',
            background: '#f6f6f6',
            position: 'relative',
            fontSize: 48,
            display: 'block',
            flexDirection: 'row',
            cursor: 'pointer',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#aaa',
            fontFamily: 'Franklin Gothic Book',
            zIndex: 5
          },
          buttonHover: {
            background: '#f9e7f2'
          },
          dot: {
            size: 10
          },
          dots: {
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 12,
            flexDirection: 'row',
            justifyContent: 'center'
          },
          shadow: {
            width: 30
          }
        })
      });

      var buttonStyle = derivation(function () {
        return IMap({
          width: pro.buttonWidth.get(),
          height: innerHeight.get()
        }).merge(pro.style.get().get('button'));
      });

      var leftButtonStyle = derivation(function () {
        return buttonStyle.get().merge({
          borderRadius: [8, 0, 0, 8]
        }).merge(hoveringLeft.get() ? pro.style.get().get('buttonHover') : undefined).merge(pro.style.get().get('leftButton'));
      });

      var rightButtonStyle = derivation(function () {
        return buttonStyle.get().merge({
          borderRadius: [0, 8, 8, 0]
        }).merge(hoveringRight.get() ? pro.style.get().get('buttonHover') : undefined).merge(pro.style.get().get('rightButton'));
      });

      var innerWidth = derivation(function () {
        return pro.width.get() - (pro.showButtons.get() ? 2 * pro.buttonWidth.get() : 0);
      });
      var innerHeight = derivation(function () {
        return pro.height.get();
      });

      var desiredIndex = atom(pro.initialSelectedIndex.get() || 0);

      pro.selectedIndex.react(function (propSelectedIndex) {
        var inc = M.util.mod(propSelectedIndex, pro.children.get().length) - M.util.mod(desiredIndex.get(), pro.children.get().length);
        desiredIndex.set(desiredIndex.get() + inc);
      }, {
        when: function when() {
          return pro.selectedIndex.get() != null;
        }
      });

      var selectedIndex = lens({
        get: function get() {
          return M.util.mod(desiredIndex.get(), pro.children.get().length);
        },
        set: function set(val) {
          if (pro.selectedIndex.get() == null) {
            desiredIndex.set(val);
          }
          view.props.onSelect && view.props.onSelect({
            selectedIndex: M.util.mod(val, pro.children.get().length)
          });
        }
      });

      selectedIndex.react(function (selectedIndex) {
        M.mixpanel.track("CarouselThingView", {
          selectedIndex: selectedIndex,
          numThings: pro.children.get().length
        });
      });

      var selectedChild = derivation(function () {
        return pro.children.get()[selectedIndex.get()] || null;
      });

      pro.children.react(function (children) {
        if (desiredIndex.get() >= children.length) {
          desiredIndex.set(pro.children.get().length - 1);
        }
      });

      var advance = function advance(inc, inputMethod) {
        if (pro.wrapMode.get() == 'cylinder') {
          selectedIndex.set(desiredIndex.get() + inc);
        } else {
          selectedIndex.set(M.util.mod(selectedIndex.get() + inc, pro.children.get().length));
        }

        M.mixpanel.track("CarouselAdvance", {
          inc: inc,
          inputMethod: inputMethod,
          numThings: pro.children.get().length
        });
      };

      var panning = atom(false);
      var panDeltaX = atom(0);

      var things = atom(List());
      var setThing = function setThing(i, thing) {
        if (!thing || things.get().contains(thing)) return;
        things.set(things.get().push(thing));

        var hammer = Hammer(thing);

        hammer.on('panstart', function (e) {
          panning.set(true);
        });

        hammer.on('pan', function (e) {
          panDeltaX.set(e.deltaX);
        });

        hammer.on('panend', function (e) {
          transact(function () {
            if (panDeltaX.get() <= 0.15 * -innerWidth.get()) {
              if (pro.wrapMode.get() == 'cylinder' || selectedIndex.get() < pro.children.get().length - 1) {
                advance(1, 'swipe');
              }
            } else if (panDeltaX.get() >= 0.15 * innerWidth.get()) {
              if (pro.wrapMode.get() == 'cylinder' || selectedIndex.get() > 0) {
                advance(-1, 'swipe');
              }
            }

            panning.set(false);
            panDeltaX.set(0);
          });
        });
      };

      var hoveringLeft = atom(false);
      var hoveringRight = atom(false);view.render(function () {
        return Flint.iff(pro.showButtons.get()) && view.el(
          ['leftSection', 1],
          { if: pro.showButtons.get() },
          Flint.iff(pro.children.get().length > 1 && (pro.wrapMode.get() || selectedIndex.get() > 0)) && view.el(
            ['button', 1],
            { className: 'leftButton',
              if: pro.children.get().length > 1 && (pro.wrapMode.get() || selectedIndex.get() > 0),
              onClick: function () {
                return advance(-1, 'button');
              },
              onMouseEnter: function () {
                return hoveringLeft.set(true);
              },
              onMouseLeave: function () {
                return hoveringLeft.set(false);
              },
              style: leftButtonStyle.get().toJS()
            },
            '<'
          )
        );
      });view.render(function () {
        return view.el(
          ['midSection', 1],
          null,
          Flint.iff(pro.shadows.get() && (selectedIndex.get() > 0 || pro.wrapMode.get() == 'cylinder')) && view.el(['leftShadow', 1], { if: pro.shadows.get() && (selectedIndex.get() > 0 || pro.wrapMode.get() == 'cylinder') }),
          Flint.iff(pro.shadows.get() && (selectedIndex.get() < pro.children.get().length - 1 || pro.wrapMode.get() == 'cylinder')) && view.el(['rightShadow', 1], { if: pro.shadows.get() && (selectedIndex.get() < pro.children.get().length - 1 || pro.wrapMode.get() == 'cylinder') }),
          view.el(
            ['things', 1],
            null,
            view.el(
              ['TransitionMotion', 1],
              {
                styles: (function () {
                  var makeStyle = function makeStyle(i) {
                    return {
                      x: (0, _reactMotion.spring)((i - desiredIndex.get()) * innerWidth.get()),
                      dx: panning.get() ? panDeltaX.get() : (0, _reactMotion.spring)(0)
                    };
                  };

                  var styles = {};
                  var start = desiredIndex.get() - (pro.wrapMode.get() == 'cylinder' ? pro.children.get().length - 1 : selectedIndex.get());
                  var end = desiredIndex.get() + (pro.wrapMode.get() == 'cylinder' ? pro.children.get().length - 1 : pro.children.get().length - 1 - selectedIndex.get());
                  for (var i = start; i <= end; view.set('i', i++, i, true)) {
                    styles[i] = makeStyle(i);
                    view.update();
                  }

                  return styles;
                })()
              },
              function (styles) {
                return Flint.range(_Object$keys(styles)).map(function (_, _index) {
                  return view.el(
                    ['thing', 1, _, _index],
                    { repeat: _Object$keys(styles),
                      key: _,
                      ref: function (elem) {
                        return setThing(_index, elem);
                      },
                      style: {
                        left: styles[_].x + styles[_].dx
                      }
                    },
                    pro.children.get()[M.util.mod(parseInt(_), pro.children.get().length)]
                  );
                });
              }
            )
          ),
          Flint.iff(pro.children.get().length > 1) && view.el(
            ['dotsSection', 1],
            { if: pro.children.get().length > 1,
              style: pro.style.get().get('dots').toJS()
            },
            Flint.iff(pro.sortable.get()) && view.el(
              ['Sortable', 1],
              { if: pro.sortable.get(),
                key: pro.children.get().map(function (c) {
                  return c.key;
                }).join('\n') + '\n' + selectedIndex.get(),
                onSort: function (e) {
                  if (e.oldIndex < selectedIndex.get()) {
                    if (e.newIndex >= selectedIndex.get()) {
                      selectedIndex.set(selectedIndex.get() - 1);
                    }
                  } else if (e.oldIndex > selectedIndex.get()) {
                    if (e.newIndex <= selectedIndex.get()) {
                      selectedIndex.set(selectedIndex.get() + 1);
                    }
                  } else if (e.oldIndex == selectedIndex.get()) {
                    selectedIndex.set(e.newIndex);
                  }
                  view.props.onSort(e);
                }
              },
              Flint.range(pro.children.get()).map(function (_, _index) {
                return view.el(['dot', 1, _, _index], { repeat: pro.children.get(),
                  onClick: function () {
                    var inc = _index - M.util.mod(desiredIndex.get(), pro.children.get().length);
                    selectedIndex.set(desiredIndex.get() + inc);
                  }
                });
              })
            ),
            Flint.iff(!pro.sortable.get()) && Flint.range(pro.children.get()).map(function (_, _index) {
              return view.el(['dot', 2, _, _index], { if: !pro.sortable.get(), repeat: pro.children.get(),
                onClick: function () {
                  var inc = _index - M.util.mod(desiredIndex.get(), pro.children.get().length);
                  selectedIndex.set(desiredIndex.get() + inc);
                  M.mixpanel.track("CarouselDotClick", {
                    dotIndex: _index,
                    numThings: pro.children.get().length
                  });
                }
              });
            })
          )
        );
      });view.render(function () {
        return Flint.iff(pro.showButtons.get()) && view.el(
          ['rightSection', 1],
          { if: pro.showButtons.get() },
          Flint.iff(pro.children.get().length > 1 && (pro.wrapMode.get() || selectedIndex.get() < pro.children.get().length - 1)) && view.el(
            ['button', 2],
            { className: 'rightButton',
              if: pro.children.get().length > 1 && (pro.wrapMode.get() || selectedIndex.get() < pro.children.get().length - 1),
              onClick: function () {
                return advance(1, 'button');
              },
              onMouseEnter: function () {
                return hoveringRight.set(true);
              },
              onMouseLeave: function () {
                return hoveringRight.set(false);
              },
              style: rightButtonStyle.get().toJS()
            },
            '>'
          )
        );
      });

      $["leftSection"] = function (_, _index) {
        return {
          width: pro.buttonWidth.get()
        };
      };

      $["midSection"] = function (_, _index) {
        return { width: innerWidth.get(),
          height: innerHeight.get() };
      };

      $["things"] = function (_, _index) {
        return {
          width: innerWidth.get(),
          height: innerHeight.get() };
      };

      $["leftShadow"] = function (_, _index) {
        return { width: pro.style.get().get('shadow').get('width') };
      };

      $["rightShadow"] = function (_, _index) {
        return { width: pro.style.get().get('shadow').get('width') };
      };

      $["rightSection"] = function (_, _index) {
        return {
          width: pro.buttonWidth.get()
        };
      };

      '2530395c';

      $["dot"] = function (_, _index) {
        return { width: pro.style.get().get('dot').get('size'),
          height: pro.style.get().get('dot').get('size'), background: _index == selectedIndex.get() ? context.colors.get().accent : '#999',
          cursor: pro.sortable.get() ? 'move' : 'pointer'
        };
      };

      $["thing"] = function (_, _index) {
        return { width: innerWidth.get(),
          height: innerHeight.get()
        };
      };
    });
  })
})();
//# sourceMappingURL=carousel.js.map
